import axios from 'axios';
import React, { useRef, useState } from 'react'
import { saveAs } from 'file-saver';
import { ColumnHeader } from './functions';
import { Encodingkeys } from './functions';
import { replaceEncodingIssue } from "./functions";
import Dropdown from '../components/Dropdown';
import * as XLSX from 'xlsx';
import Kentrix_Enrichment_Data_Dictionary from "../assets/Kentrix_Enrichment_Data_Dictionary_2023.xlsx"

const BatchURLSPage = ({ setShowAlert, setAlertMessage, BatchTypeDict,setLoading, batchType,setBatchType,setProgressLoading, progressPercentage, setProgressPercentage,flap,isBatch,user,refreshQuota }) => {

    const [addresses, setAddresses] = useState([]);
    const [gps, setGPS] = useState([]);
    const [responses, setResponses] = useState({});
    
    const fileInputRef = useRef(null);
    const [inBetweenError, setInBetweenError] = useState("")

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        const validExcelMimeTypes = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.ms-excel" // Add any other valid MIME types
        ];
    
        try{
            if (!validExcelMimeTypes.includes(file.type)) {
                setAlertMessage("Invalid file type. Please upload an Excel file.");
                setShowAlert(true);
                fileInputRef.current.value = '';
                return;
            }
        }
        catch{
            setAlertMessage("Invalid file type. Please upload an Excel file.");
            setShowAlert(true);
            fileInputRef.current.value = '';
            return;
        };

    
    
        const reader = new FileReader();
        reader.onload = (event) => {
            const excelData = event.target.result;
            const addressesArray = parseExcel(excelData);
            if (addressesArray) {
                setAddresses(addressesArray);
            } else {
                fileInputRef.current.value = '';
            }
        };
        reader.readAsArrayBuffer(file);
    };

    const handleFileChangeGPS = (e) => {
        const file = e.target.files[0];
        const validExcelMimeTypes = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.ms-excel" // Add any other valid MIME types
        ];
        try{
            if (!validExcelMimeTypes.includes(file.type)) {
                setAlertMessage("Invalid file type. Please upload an Excel file.");
                setShowAlert(true);
                fileInputRef.current.value = '';
                return;
            }
        }
        catch{
            setAlertMessage("Invalid file type. Please upload an Excel file.");
            setShowAlert(true);
            fileInputRef.current.value = '';
            return;
        };

    
    
        const reader = new FileReader();
        reader.onload = (event) => {
            const excelData = event.target.result;
            const gpsArray = parseExcelGPS(excelData);
            // console.log("gpsArray",gpsArray);
            if (gpsArray) {
                setGPS(gpsArray);
            } else {
                fileInputRef.current.value = '';
            }
        };
        reader.readAsArrayBuffer(file);
    };


    

    const parseExcel = (excelData) => {
        const workbook = XLSX.read(excelData, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        const addressesArray = [];
        const range = XLSX.utils.decode_range(sheet["!ref"]);
        if (range.e.r > 200) {
            setAlertMessage("The file exceeds the 200 record limit.");
            setShowAlert(true);
            return null;
        }

        const headerRow = XLSX.utils.decode_range(sheet["!ref"]).s.r;
        const headerColumns = [];

        for (let col = range.s.c; col <= range.e.c; col++) {
            const cell = sheet[XLSX.utils.encode_cell({ r: headerRow, c: col })];
            if (cell && cell.v) {
                headerColumns.push(cell.v.trim().toLowerCase());
            }
        }

        const addressIndex = headerColumns.indexOf("address");
        const idIndex = headerColumns.indexOf("id");

        if (addressIndex === -1 || idIndex === -1) {
            setAlertMessage("Invalid Excel file: Missing 'address' or 'id' header.");
            setShowAlert(true);
            return null;
        }


        for (let row = range.s.r + 1; row <= range.e.r; row++) {
            const addressCell = sheet[XLSX.utils.encode_cell({ r: row, c: addressIndex })];
            const IDCell = sheet[XLSX.utils.encode_cell({ r: row, c: idIndex })];
        
            if (addressCell) {
                let cellValue = addressCell.v;
        
                if (typeof cellValue === 'number') {
                    cellValue = String(cellValue); // Convert number to string
                }
        
                if (typeof cellValue === 'string') {
                    const cleanedAddress = cellValue.trim();
                    if (cleanedAddress !== "") {
                        addressesArray.push([IDCell.v,cleanedAddress]);
                    }
                }
            }
        }
        // console.log(addressesArray);
        return addressesArray;
    };

    const parseExcelGPS = (excelData) => {
        const workbook = XLSX.read(excelData, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        const gpsArray = [];
        const range = XLSX.utils.decode_range(sheet["!ref"]);
        if (range.e.r > 200) {
            setAlertMessage("The file exceeds the 200 record limit.");
            setShowAlert(true);
            return null;
        }
        const headerRow = XLSX.utils.decode_range(sheet["!ref"]).s.r;
        const headerColumns = [];

        for (let col = range.s.c; col <= range.e.c; col++) {
            const cell = sheet[XLSX.utils.encode_cell({ r: headerRow, c: col })];
            if (cell && cell.v) {
                headerColumns.push(cell.v.trim().toLowerCase());
            }
        }
        const lngIndex = headerColumns.indexOf("longitude");
        const latIndex = headerColumns.indexOf("latitude");
        const idIndex = headerColumns.indexOf("id");

        if (latIndex === -1 || lngIndex === -1 || idIndex === -1) {
            setAlertMessage("Invalid Excel file: Missing 'id','latitude' or 'longitude' header.");
            setShowAlert(true);
            return null;
        }


        for (let row = range.s.r + 1; row <= range.e.r; row++) {
            const latCell = sheet[XLSX.utils.encode_cell({ r: row, c: latIndex })];
            const lngCell = sheet[XLSX.utils.encode_cell({ r: row, c: lngIndex })];
            const IDCell = sheet[XLSX.utils.encode_cell({ r: row, c: idIndex })];
            gpsArray.push([latCell.v,lngCell.v,IDCell.v]);
            
        }
        // console.log(gpsArray);
        return gpsArray;
    };



    // const handleFileChange = (e) => {
    //     const file = e.target.files[0];
    //     const reader = new FileReader();
    //     reader.onload = (event) => {
    //         const csvData = event.target.result;
    //         const addressesArray = parseCSV(csvData);
    //         if (addressesArray) {
    //             setAddresses(addressesArray);
    //         } else {
    //             fileInputRef.current.value = '';
    //         }
    //     };
    //     reader.readAsText(file);
    // };



    // const parseCSV = (csvData) => {
    //     const lines = csvData.split('\n');

    //     const addressesArray = [];

    //     // Check if the CSV file has at least 2 lines
    //     if (lines.length > 1) {
    //         const headerColumns = lines[0].split(',');
    //         const addressIndex = headerColumns.findIndex((column) => column.trim().toLowerCase() === 'address');

    //         if (addressIndex !== -1) {
    //             try {
    //                 for (let i = 1; i < lines.length; i++) {
    //                     const line = lines[i].trim();
    //                     const firstCommaIndex = line.indexOf(',');
    //                     // const id = line.substring(0, firstCommaIndex).trim();
    //                     const full_address = line.substring(firstCommaIndex + 1).trim(); // Get the portion after the first comma

    //                     const cleaned_address = full_address.replace(/\s+/g, ' '); // Remove extra spaces from full_address
    //                     if (cleaned_address !== '') {
    //                         addressesArray.push(cleaned_address);
    //                     }
    //                 }
    //                 return addressesArray;
    //             } catch (error) {
    //                 setAlertMessage('Wrong CSV Format ' + error);
    //                 setShowAlert(true);
    //             }
    //         } else {
    //             setAlertMessage('Invalid CSV file: Missing "address" header.');
    //             setShowAlert(true);
    //         }
    //     } else {
    //         setAlertMessage("Invalid CSV file: At least one data row is required.");
    //         setShowAlert(true);
    //     }
    // };



    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
    const handleOnInputSend = async (e) => {
        if (addresses && addresses.length > 0) {
            setProgressLoading(true);
            setInBetweenError("");
            let response_key = 0
            let error_key = 0

            const responseDict = {
                response_data: [],
                response_addresses: []
            };

            const totalAddresses = addresses.length;
            let completedAddresses = 0;
            let leftAddresses = 0
            let first=true;
            for (let i = 0; i < totalAddresses; i++) {
                const address = addresses[i];
                try {
                    const response = await axios.get(user.api_url, {
                        params: {
                            address: address[1].toLowerCase(),
                            unique_id: Date.now(),
                            username:user.username
                        },
                        headers: {
                            'X-Api-Key': user.api_key,
                            'Content-Type': 'application/json',
                        },
                    });

                    responseDict.response_data.push(response.data.response);
                    responseDict.response_addresses.push([address[0],address[1]]);
                    completedAddresses++;
                    const progressPercentage = Math.floor((completedAddresses / totalAddresses) * 100);
                    setProgressPercentage(progressPercentage);
                    setResponses(responseDict);
                    response_key = 1
                    if (first === true){
                        first=false;
                        await delay(3000);
                    }
                    else{
                        await delay(1500);
                    }

                    // if (i < totalAddresses - 1) {
                    //     await delay(1500);
                    // }

                }
                catch (error) {
                    if (error.response) {
                        if (error.response.status === 429) {
                            setAlertMessage("API Limit Exceeded: " + error.message);
                        } else if (error.response.status === 403) {
                            setAlertMessage("Forbidden. Wrong API key: " + error.message);
                        } else if (error.response.status === 504 || error.response.status === 500 || error.response.status === 401 || error.response.status === 502) {
                            setAlertMessage("Please Contact Kentrix: " + error.message);
                        } else {
                            setAlertMessage("An unexpected error occurred." + error);
                        }
                    } else if (error.message === "Network Error") {
                        setAlertMessage("Forbidden. Wrong API URL: " + error.message);
                    } else {
                        setAlertMessage("An unexpected error occurred.");
                    }
                    setShowAlert(true);
                    leftAddresses = totalAddresses - completedAddresses
                    setInBetweenError(completedAddresses + " address successfully fetched, " + leftAddresses + " left");
                    error_key = 1
                    setProgressLoading(false);
                    break;
                }
            }

            if (response_key === 1 && error_key === 0) {
                setAlertMessage("Data successfully fetched.");
                setShowAlert(true);
                refreshQuota();

            }

            setProgressPercentage(0);
            setProgressLoading(false);

        } else {
            setAlertMessage('Please upload the excel file.');
            setShowAlert(true);
        }
    };
    const handleOnInputSendGPS = async (e) => {
        if (gps && gps.length > 0) {
            setProgressLoading(true);
            setInBetweenError("");
            let response_key = 0
            let error_key = 0

            const responseDict = {
                response_data: [],
                response_gps_cord: []
            };

            const totalAddresses = gps.length;
            let completedAddresses = 0;
            let leftAddresses = 0

            for (let i = 0; i < totalAddresses; i++) {
                const gpsCordinates = gps[i];
                try {
                    const response = await axios.get(user.gps_api_url, {
                        params: {
                            latitude:gpsCordinates[0],
                            longitude:gpsCordinates[1],
                            unique_id: Date.now(),
                            username:user.username
                        },
                        headers: {
                            'X-Api-Key': user.gps_api_key,
                            'Content-Type': 'application/json',
                        },
                    });

                    responseDict.response_data.push(response.data.response);
                    responseDict.response_gps_cord.push([gpsCordinates[2],gpsCordinates[0],gpsCordinates[1]]);
                    completedAddresses++;
                    const progressPercentage = Math.floor((completedAddresses / totalAddresses) * 100);
                    setProgressPercentage(progressPercentage);
                    setResponses(responseDict);
                    response_key = 1
                    await delay(1500);

                    // if (i < totalAddresses - 1) {
                    //     await delay(1500);
                    // }

                }
                catch (error) {
                    if (error.response) {
                        if (error.response.status === 429) {
                            setAlertMessage("API Limit Exceeded: " + error.message);
                        } else if (error.response.status === 403) {
                            setAlertMessage("Forbidden. Wrong API key: " + error.message);
                        } else if (error.response.status === 504 || error.response.status === 500 || error.response.status === 401 || error.response.status === 502) {
                            setAlertMessage("Please Contact Kentrix: " + error.message);
                        } else {
                            setAlertMessage("An unexpected error occurred." + error);
                        }
                    } else if (error.message === "Network Error") {
                        setAlertMessage("Forbidden. Wrong API URL: " + error.message);
                    } else {
                        setAlertMessage("An unexpected error occurred.");
                    }
                    setShowAlert(true);
                    leftAddresses = totalAddresses - completedAddresses
                    setInBetweenError(completedAddresses + " address successfully fetched, " + leftAddresses + " left");
                    error_key = 1
                    setProgressLoading(false);
                    break;
                }
            }
            if (response_key === 1 && error_key === 0) {
                setAlertMessage("Data successfully fetched.");
                setShowAlert(true);
                refreshQuota();

            }

            setProgressPercentage(0);
            setProgressLoading(false);

        } else {
            setAlertMessage('Please upload the excel file.');
            setShowAlert(true);
        }
    };


    const modifiedResponses = () => {
        if (responses && responses.response_data) {
            return responses.response_data.map((obj) => {
                const modifiedObj = {};
                for (const [key, value] of Object.entries(obj)) {
                    modifiedObj[key] = value === null || value === "" ? "None" : value;
                }
                return modifiedObj;
            });
        }
        return [];
    };


    // const exportToCSV = () => {
    //     const columnHeaderRow = `"Address",${ColumnHeader.map(
    //         (header) => `"${escapeDoubleQuotes(replaceEncodingIssue(header))}"`
    //     ).join(",")}`;

    //     const modifiedResponseData = modifiedResponses();
    //     const addressRows = responses.response_addresses.map((address, index) => {
    //         const valuesRow = `"${escapeDoubleQuotes(replaceEncodingIssue(address))}",${Encodingkeys.map(
    //             (key) => {
    //                 const value = modifiedResponseData[index] ? modifiedResponseData[index][key] || "" : "";
    //                 return `"${escapeDoubleQuotes(replaceEncodingIssue(value))}"`;
    //             }
    //         ).join(",")}`;
    //         return `${valuesRow}`;
    //     });

    //     const finalCSVContent = `${columnHeaderRow}\n${addressRows.join("\n")}`;
    //     const blob = new Blob([finalCSVContent], { type: "text/csv;charset=utf-8" });
    //     saveAs(blob, "data.csv");
    // };

    const exportData = async () => {
        try {
            const columnHeaderRow = ["ID","Address", ...ColumnHeader.map(header => replaceEncodingIssue(header))];

            const modifiedResponseData = modifiedResponses();
            const addressRows = responses.response_addresses.map((address, index) => {
                const valuesRow = [address[0],replaceEncodingIssue(address[1]), ...Encodingkeys.map(key => {
                    const value = modifiedResponseData[index] ? modifiedResponseData[index][key] || "" : "";
                    return replaceEncodingIssue(value);
                })];
                return valuesRow;
            });

            const data = [columnHeaderRow, ...addressRows];
            const worksheet = XLSX.utils.aoa_to_sheet(data); // Convert array of arrays to worksheet

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Output"); // Add the first worksheet to the workbook

            // Read the Kentrix_Urban Excel file
            const response = await fetch(Kentrix_Enrichment_Data_Dictionary);
            const buffer = await response.arrayBuffer();
            const KentrixEnrichmentWorkbook = XLSX.read(buffer, { type: "array" });

            // Assuming Kentrix_Urban.xlsx contains only one sheet, you can directly access it
            const kentrixUrbanWorksheet = KentrixEnrichmentWorkbook.Sheets[KentrixEnrichmentWorkbook.SheetNames[0]];
            const kentrixRuralWorksheet = KentrixEnrichmentWorkbook.Sheets[KentrixEnrichmentWorkbook.SheetNames[1]];

            // Add the Kentrix_Urban worksheet to the existing workbook
            XLSX.utils.book_append_sheet(workbook, kentrixUrbanWorksheet, "Enrichment Dictionary -Urban");
            XLSX.utils.book_append_sheet(workbook, kentrixRuralWorksheet, "Enrichment Dictionary -Rural");

            // Convert the workbook to Excel buffer
            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

            saveAs(blob, "Output.xlsx");
        } catch (error) {
            setAlertMessage("Error exporting data:", error);
            setShowAlert(true);
        }
    };
    const exportDataGPS = async () => {
        try {
            const columnHeaderRow = ["ID","Latitude","Longitude", ...ColumnHeader.map(header => replaceEncodingIssue(header))];

            const modifiedResponseData = modifiedResponses();
            // console.log(responses);
            const addressRows = responses.response_gps_cord.map((gps_cord, index) => {
                const valuesRow = [gps_cord[0],gps_cord[1],gps_cord[2], ...Encodingkeys.map(key => {
                    const value = modifiedResponseData[index] ? modifiedResponseData[index][key] || "" : "";
                    return replaceEncodingIssue(value);
                })];
                return valuesRow;
            });
            // console.log(addressRows);
            const data = [columnHeaderRow, ...addressRows];
            const worksheet = XLSX.utils.aoa_to_sheet(data); // Convert array of arrays to worksheet

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Output"); // Add the first worksheet to the workbook

            // Read the Kentrix_Urban Excel file
            const response = await fetch(Kentrix_Enrichment_Data_Dictionary);
            const buffer = await response.arrayBuffer();
            const KentrixEnrichmentWorkbook = XLSX.read(buffer, { type: "array" });

            // Assuming Kentrix_Urban.xlsx contains only one sheet, you can directly access it
            const kentrixUrbanWorksheet = KentrixEnrichmentWorkbook.Sheets[KentrixEnrichmentWorkbook.SheetNames[0]];
            const kentrixRuralWorksheet = KentrixEnrichmentWorkbook.Sheets[KentrixEnrichmentWorkbook.SheetNames[1]];

            // Add the Kentrix_Urban worksheet to the existing workbook
            XLSX.utils.book_append_sheet(workbook, kentrixUrbanWorksheet, "Enrichment Dictionary -Urban");
            XLSX.utils.book_append_sheet(workbook, kentrixRuralWorksheet, "Enrichment Dictionary -Rural");

            // Convert the workbook to Excel buffer
            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

            saveAs(blob, "Output.xlsx");
        } catch (error) {
            setAlertMessage("Error exporting data:", error);
            setShowAlert(true);
        }
    };







    return (
        <div>
            <div className="item_section">

                <div className="input_para_container">
                    <div className="input_para">
                        <Dropdown disabled={!isBatch} filterName="Batch Type" filterObject={BatchTypeDict} filterValue={batchType} setFilterValue={setBatchType} />
                        {/* <select class="form-select  shadow-none for_disable">
                            <option selected>Select Batch Type</option>
                            <option value="Address">Address</option>
                            <option value="GPS">GPS</option>
                        </select> */}
                        <input
                            accept=".xlsx, .xls"
                            type="file"
                            className="form-control  shadow-none for_disable"
                            onChange={(batchType === 'ADDRESS') ? handleFileChange:handleFileChangeGPS}
                            ref={fileInputRef} // Add the ref to the file input element
                            disabled={!isBatch}
                        />
                        <button
                            onClick={(batchType === 'ADDRESS') ? handleOnInputSend:handleOnInputSendGPS}
                            disabled={!isBatch}
                        >Submit</button>
                    </div>
                                        {(batchType === 'ADDRESS') ? (
                    <p>Upload Excel (.xlsx, .xls format) file. <br />(Address file should only contain one sheet having two columns headers: "id" and "address") <br/>(Maximum 200 records allowed for Excel upload. Operation may take up to 5-7 minutes.)</p>
                    ) : (
                    <p>Upload Excel (.xlsx, .xls format) file. <br />(GPS file should only contain one sheet having three columns headers: "id", "latitude" and "longitude") <br/>(Maximum 200 records allowed for Excel upload. Operation may take up to 5-7 minutes.)</p>
                    )}

                </div>

                {inBetweenError && responses.response_data && (
                    <div className="between_error">
                        {inBetweenError}
                    </div>
                )}


                <div className="btn_download">
                    <button
                        onClick={(batchType === 'ADDRESS') ? exportData:exportDataGPS}
                        disabled={!responses.response_data || responses.response_data.length === 0}
                        className={!responses.response_data || responses.response_data.length === 0 ? "disabled" : ""}
                    >
                        Download Data
                    </button>
                </div>





            </div>

        </div>
    )
}

export default BatchURLSPage
